import zeroHeroes from './zeroHeroes';
import keepCool from './keepCool';
import epsPrimaries from './epsPrimaries';
import epsIntermediates from './epsIntermediates';
import epsHybridAssembly from './epsHybridAssembly';
import epsHybridPrimaries from './epsHybridPrimaries';
import epsHybridIntermediates from './epsHybridIntermediates';
import h2whoa from './h2whoa';
import h2whoaHybrid from './h2whoaHybrid';


const programList = [
  zeroHeroes,
  keepCool,
  h2whoa,
  epsPrimaries,
  epsIntermediates,
  epsHybridAssembly,
  epsHybridPrimaries,
  epsHybridIntermediates,
  h2whoaHybrid
];

// Generate a lookup table by program id
const programLookup = programList.reduce((previous, program) => {
  return {
    [program.id]: program,
    ...previous
  };
}, {});

const programs = {
  programList,
  programLookup
};

export default programs;



// WEBPACK FOOTER //
// ./programs/index.js